<div class="text-center">
    <mat-icon class="alert-icon text-center">error</mat-icon>
</div>

<mat-dialog-content class="text-center">
    <p class="content">{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions align="center">
    <button class="cancel-btn" mat-raised-button (click)="onAction(false)">No</button>
    <button class="confirm-btn" mat-raised-button (click)="onAction(true)">Yes</button>
</mat-dialog-actions>